module.exports = __webpack_public_path__ + "static/img/fellowChickenTop.0e1081e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fellowChickenTop.png
// module id = yldN
// module chunks = 2